import React, { useState } from 'react';

const exportToCSV = (data, headers, filename) => {
  const csvHeaders = headers.map(h => h.label).join(',');
  const csvRows = data.map(row =>
    headers.map(h => {
      let val = row[h.key] ?? '';
      if (typeof val === 'string' && (val.includes(',') || val.includes('"') || val.includes('\n'))) {
        val = `"${val.replace(/"/g, '""')}"`;
      }
      return val;
    }).join(',')
  );
  const csvContent = [csvHeaders, ...csvRows].join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${filename}_${new Date().toISOString().split('T')[0]}.csv`;
  link.click();
  URL.revokeObjectURL(link.href);
};

const exportToPDF = (data, headers, title, filename) => {
  const printWindow = window.open('', '_blank');
  const tableHeaders = headers.map(h => `<th style="padding:10px 14px;text-align:left;background:#f82581;color:#fff;font-weight:600;font-size:13px;border-bottom:2px solid #d91e6e;">${h.label}</th>`).join('');
  const tableRows = data.map((row, i) =>
    `<tr style="background:${i % 2 === 0 ? '#fafafa' : '#fff'}">` +
    headers.map(h => `<td style="padding:9px 14px;font-size:13px;color:#333;border-bottom:1px solid #eee;">${row[h.key] ?? ''}</td>`).join('') +
    '</tr>'
  ).join('');

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>${title}</title>
      <style>
        body { font-family: 'Segoe UI', Arial, sans-serif; padding: 30px; color: #333; }
        .header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; padding-bottom: 16px; border-bottom: 3px solid #f82581; }
        .header h1 { font-size: 22px; margin: 0; color: #1a1a2e; }
        .header .meta { font-size: 12px; color: #888; text-align: right; }
        table { width: 100%; border-collapse: collapse; margin-top: 12px; }
        .footer { margin-top: 24px; padding-top: 12px; border-top: 1px solid #ddd; font-size: 11px; color: #999; display: flex; justify-content: space-between; }
        @media print { body { padding: 15px; } .no-print { display: none; } }
      </style>
    </head>
    <body>
      <div class="header">
        <h1>${title}</h1>
        <div class="meta">
          <div>HikeCinema Admin Report</div>
          <div>${new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</div>
          <div>${new Date().toLocaleTimeString()}</div>
        </div>
      </div>
      <table>
        <thead><tr>${tableHeaders}</tr></thead>
        <tbody>${tableRows}</tbody>
      </table>
      <div class="footer">
        <span>Total records: ${data.length}</span>
        <span>Generated by HikeCinema Admin Panel</span>
      </div>
      <script>window.onload = function() { window.print(); }</script>
    </body>
    </html>
  `);
  printWindow.document.close();
};

const ExportButtons = ({ data, headers, title, filename }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <div className="export-btn-wrapper" style={{ position: 'relative', display: 'inline-block' }}>
      <button
        className="export-trigger-btn"
        onClick={() => setShowDropdown(!showDropdown)}
        onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
      >
        <i className="fas fa-download"></i> Export
        <i className={`fas fa-chevron-${showDropdown ? 'up' : 'down'}`} style={{ marginLeft: '6px', fontSize: '10px' }}></i>
      </button>
      {showDropdown && (
        <div className="export-dropdown">
          <button onClick={() => { exportToCSV(data, headers, filename); setShowDropdown(false); }}>
            <i className="fas fa-file-csv"></i> Export as CSV
          </button>
          <button onClick={() => { exportToPDF(data, headers, title, filename); setShowDropdown(false); }}>
            <i className="fas fa-file-pdf"></i> Export as PDF
          </button>
        </div>
      )}
    </div>
  );
};

export default ExportButtons;
